import React from 'react';
import { useTranslation } from 'react-i18next';

export default function SuggestionButton({ id, openItems = {}, toggleOpen = () => {} }) {
  const { t } = useTranslation();
  const open = !!openItems[id];
  return (
    <button
      onClick={() => toggleOpen(id)}
      className="text-sm font-medium text-yellow-600 hover:underline w-1/3 flex justify-end"
    >
      <p>{open ? t('cyber_surveillance.hide_suggestions') : t('cyber_surveillance.show_suggestions')}</p>
    </button>
  );
}
